// extracted by mini-css-extract-plugin
module.exports = {"signButton":"SignUpButton_signButton__MdfBu","text":"SignUpButton_text__PmxKd"};